<mat-card>
  <mat-card-header>
    <h1 mat-card-title>{{ 'thank_you_for_registering_with_supplycanvas_tr' | translate }}</h1>
  </mat-card-header>

  <mat-card-content>
    <div>
      {{ 'excited_to_have_you_tailored_your_goals_tr' | translate }}
    </div>

    <div>
      {{ 'choose_a_time_that_works_before_full_access_tr' | translate }}
    </div>

    <form-actions>
      <button type="button" (click)="schedulaCall()" color="primary" mat-raised-button>
        <mat-icon>schedule</mat-icon>
        {{ 'pick_a_time_tr' | translate }}
      </button>
    </form-actions>

    @if (adminAvailable) {
      <div class="contact-now-section">
        <h3>{{ 'need_immediate_assistance_tr' | translate }}</h3>
        <p>{{ 'connect_with_us_directly_tr' | translate }}</p>
        <div class="contact-buttons">
          <button type="button" (click)="startTeamsCall()" color="primary" mat-raised-button>
            <mat-icon>people</mat-icon>
            {{ 'Microsoft_teams_tr' | translate }}
          </button>
          gunther.hentschel&#64;supplycanvas.com
        </div>
        <div class="contact-buttons">
          <a href="tel:+4934135224422" color="primary" mat-raised-button>
            <mat-icon>phone</mat-icon>
            {{ 'start_phone_call_tr' | translate }}
          </a>
          +49 341 35224422
        </div>
      </div>
    }
  </mat-card-content>
</mat-card>
